import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { MarketplacePageComponent } from "../../marketplace/marketplace.component";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { SharedService } from "src/app/shareModule/services/shared.service";
import { Location } from "@angular/common";
import { Router, NavigationEnd, Event as NavigationEvent } from "@angular/router";
import { environment } from "src/environments/environment";
import { ArticlesCarsouelComponent } from "../articles-carsouel/articles-carsouel.component";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import moment from "moment";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { BehaviorSubject, filter, Subject, take, takeUntil, distinctUntilChanged } from "rxjs";
import { select, Store } from "@ngrx/store";
import { loadUser, selectUser } from "src/app/shareModule/states/user-details";
import { User } from "src/app/shareModule/models/user.model";
import { AppState } from "src/app/shareModule/states/app.state";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AdServiceService } from "src/app/ad-service.service";
import { CommonService } from "src/app/shareModule/services/common.service";

@Component({
  selector: "app-member-page",
  templateUrl: "./member-page.component.html",
  styleUrls: ["./member-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberPageComponent implements AfterViewInit, OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild("marketplace", { static: true }) marketplacePage: MarketplacePageComponent;

  public supportOwnerList: any[] = [];
  public selectedJob: any = null;
  public allBizProductByRegion: Array<any> = [];
  public jobList: Array<any> = [];
  private modalRef: any;
  playAnimation = true;
  onlineMembers: any[] = [];
  showOnlineMembers = false;

  public tabs = [
    { title: "News" },
    { title: "Friends" },
    { title: "Recommended Nearby" },
    { title: "Jobs" }
  ];

  carouselOptions = {
    spaceBetween: 10,
    breakpoints: {
      0: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 3 },
      1200: { slidesPerView: 6 }
    }
  };

  imgUrl = environment.ImageUrl;
  @ViewChild("articlesCarsouelComponent") articlesCarsouelComponent: ArticlesCarsouelComponent;
  public selectedMemberRegion = "";
  private scrollPosition: [number, number] = [0, 0];
  public bannerImagesList: Array<any> = [];
  public commonModalRef: any = null;

  item = {
    0: {
      items: 2
    }
  };

  public userName = '';

  /************************************* Ads *******************************************/
  @ViewChild('leftAd', { static: true }) leftAd: ElementRef;
  @ViewChild('rightAd', { static: true }) rightAd: ElementRef;

  public get showAdRight() {
    return this.adsService.showAdRight;
  }

  public get currentRightAd() {
    return this.adsService.currentRightAd;
  }

  public tempCloseAdRight() {
    return this.adsService.tempCloseAdRight();
  }

  public get showAdLeft() {
    return this.adsService.showAdLeft;
  }

  public get currentLeftAd() {
    return this.adsService.currentLeftAd;
  }

  public tempCloseAdLeft() {
    return this.adsService.tempCloseAdLeft();
  }
  /************************************************************************************ */

  constructor(
    private readonly local: LocalServiceService,
    private readonly auth: AuthServiceService,
    private readonly title: Title,
    private readonly sharedService: SharedService,
    private readonly location: Location,
    private readonly router: Router,
    private readonly customerService: CustomerService,
    public readonly roleService: RoleService,
    private readonly store: Store<AppState>,
    private readonly modalService: NgbModal,
    private readonly adsService: AdServiceService,
    private readonly commonService: CommonService,
    private readonly cdr: ChangeDetectorRef,
    @Inject("WINDOW") private readonly window: any,
  ) {
    // Role *****
    this.roleService.rolesSubject
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged()
      )
      .subscribe((roles) => {
        if (roles?.level.includes("MEMBER_COMMUNITY_VOUCHERS_TAB")) {
          this.tabs.push({ title: "Vouchers" });
          this.cdr.detectChanges();
        }
      });

    this.local.getUserDetailsObserver()
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged()
      )
      .subscribe((user) => {
        if (user?.id) {
          this.user = user;
          this.store.dispatch(loadUser({}));
          this._getBannerList();
        }
      });

    this.getProfileCharacterDetails();
  }

  ngOnDestroy(): void {
    console.log("[Start Destroy] Member Page Component")
    this.local.clearTimeout(this.timeout1)
    if (this.sharedService.isBrowser()) {
      this.adsService.disposeAds();
    }
    this.destroy$.next();
    this.destroy$.complete();
    console.log("[End Destroy] Member Page Component")
  }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.adsService.getSiteAds(this.leftAd, this.rightAd);
    }

    this.auth.getMemberShopSubRegion()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => {
          this.subRegions = Array.from(data.body);
          this.cdr.detectChanges();
        },
        error: err => console.error(err)
      });
  }

  public servicesSubRegionChange(event): void {
    const id = event.target.value;
    const region = this.subRegions.find(s => s.subRegionId === id);

    if (!region) {
      console.error("Could not find subregion with id", id);
      return;
    }

    this.selectedMemberRegion = region.name;
    this.sharedService.servicesShowingSubRegion.next(region);
    this.cdr.detectChanges();
  }

  public subRegions: any[] = [];

  public get isLocationNeaby(): boolean {
    return this.sharedService.isBrowser() && this.window.location.href.includes('nearby');
  }

  goBack(): void {
    this.commonService.goBack();
  }

  user: any = {};
  url = "";
  indexTab = 0;

  ngAfterViewInit(): void {
    this.url = this.router.url;

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        this.window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
        this.url = event.urlAfterRedirects;
        this.cdr.detectChanges();
      });

    this.sharedService.initMembers$
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: any) => {
        this.indexTab = params;
        this.cdr.detectChanges();
      });
  }

  onNavigate(url: string): void {
    this.scrollPosition = [this.window.scrollX, this.window.scrollY];
    this.router.navigate([`/me/${url}`]);
  }

  supported: any[] = [];
  getSupported(): void {
    this.customerService.getSupported()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.supported = resp.body;
        this.cdr.detectChanges();
      });
  }

  private _getBannerList(): void {
    this.auth.getAllMemberPageBanner()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.bannerImagesList = resp.body
          .filter((i) => i.subRegion === "default" || i.subRegion === this.selectedMemberRegion.split("|")[1])
          .map((i) => ({ image: i.image, url: i.url }));
        this.cdr.detectChanges();
      });
  }

  bgBody = '';
  public getProfileCharacterDetails(): void {
    this.store
      .pipe(
        select(selectUser),
        filter((user) => !!user),
        takeUntil(this.destroy$),
        distinctUntilChanged()
      )
      .subscribe((r: User) => {
        this.bgBody = r?.bgBody;
        this.userName = r?.profileCharacterName || this.maskNumber(r?.phone);

        if (r?.regionName) {
          this.selectedMemberRegion = r.regionName;
          if (this.articlesCarsouelComponent) {
            this.articlesCarsouelComponent.getArticlesList(1, "", r.regionName);
          }
        }
        this.cdr.detectChanges();
      });
  }

  public regionSplit(name: string): string {
    return name && name.includes("|") ? name.split("|")[1] : "";
  }

  public maskNumber(number: any): string {
    return number ? number.toString().replace(/\d(?=\d{4})/g, "*") : "";
  }

  redirectLink(url: string): void {
    if (url && url !== "") {
      this.window.open("http://" + url, "_blank");
    }
  }

  public timeout1: any;
  openShopPopup(name: string): void {
    this.local.clearTimeout(this.timeout1)
    this.sharedService.triggerInitTabProfile("shop");
    this.timeout1 = setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(name);
    }, 100);
  }

  userReferralUploadedFile: any[] = [];

  getReferralUploadedFiles(category = "voucher"): void {
    this.auth.userReferralUploadedFile(null, category)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.userReferralUploadedFile = response.body;
        this.cdr.detectChanges();
      });
  }

  public navigateToShop(item: any): void {
    const route = item.type === "community"
      ? ["/profile", item?.businessDetails?.referralCode]
      : ["/biz/shop", item.business_id];
    this.router.navigate(route);
  }

  private getBizProductList(): void {
    const params = {
      postalCode: this.user.postalCode
    };

    this.customerService.getBizByRegion(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.allBizProductByRegion = response.data;
        this.cdr.detectChanges();
      });
  }

  public getTabData(tab: number): void {
    const title = this.tabs[tab]?.title;

    switch (title) {
      case "Recommended Nearby":
        this.getBizProductList();
        break;
      case "Jobs":
        this.getJobList();
        break;
      case "Friends":
        this.getSupportList();
        break;
      case "Vouchers":
        this.getReferralUploadedFiles();
        break;
    }
  }

  public viewProductDetails(product: any): void {
    this.marketplacePage.enableMemberShop = false;
    this.marketplacePage.viewProduct(product);
  }

  public getJobList(): void {
    this.customerService.getAllJobPost()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.jobList = resp.body;
        this.cdr.detectChanges();
      });
  }

  public openJobPopup(job: any, modal: any): void {
    const currentDate = moment();
    const daysLeft = moment(job.applicationDeadline).diff(currentDate, "days") || 0;

    this.selectedJob = {
      ...job,
      daysLeft
    };

    this.updateJobView(job.id);

    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "suggestion"
    });
  }

  public updateJobView(jobId: string): void {
    this.customerService.jobPostView(jobId)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  public getSupportList(): void {
    this.customerService.getUserSupportList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.supportOwnerList = resp.body;
        this.cdr.detectChanges();
      });
  }
}
